import Vue from 'vue'
import './firebase'
import './components'
import './plugins'
import { sync } from 'vuex-router-sync'
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import VeeValidate from 'vee-validate'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import axios from 'axios'
import * as VueFire from 'vuefire'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import JsonExcel from 'vue-json-excel'
// import VueMathjax from 'vue-mathjax'
// Vue.use(VueMathjax)


Vue.use(VueFire)
Vue.use(axios)
Vue.use(Loading)


axios.defaults.baseURL = 'https://api.bacbonschool.com/api/'
// axios.defaults.baseURL = 'http://localhost:8000/api/'
Vue.use(VeeValidate)
Vue.component("downloadExcel", JsonExcel);
// Sync store with router
sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.config.errorHandler = err => {
  console.log('Exception: ', err)
}

